import { render, staticRenderFns } from "./StudentFilters.vue?vue&type=template&id=a5873788&scoped=true"
import script from "./StudentFilters.vue?vue&type=script&lang=js"
export * from "./StudentFilters.vue?vue&type=script&lang=js"
import style0 from "./StudentFilters.vue?vue&type=style&index=0&id=a5873788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5873788",
  null
  
)

export default component.exports